/* Cooked — performance helpers
 * 1. Lazy-loads hero video after first paint, desktop only, respects save-data + reduced-motion.
 * 2. Poster image is the LCP element; video upgrades the experience without blocking.
 */
(function () {
  'use strict';

  function shouldLoadVideo() {
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return false;
    if (window.matchMedia && window.matchMedia('(max-width: 749px)').matches) return false;
    var conn = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
    if (conn) {
      if (conn.saveData) return false;
      if (['slow-2g', '2g'].indexOf(conn.effectiveType) !== -1) return false;
    }
    return true;
  }

  function attachVideo(target) {
    var src = target.getAttribute('data-video-src');
    var poster = target.getAttribute('data-video-poster');
    if (!src) return;

    var video = document.createElement('video');
    video.className = 'cooked-hero__video';
    video.muted = true;
    video.loop = true;
    video.autoplay = true;
    video.playsInline = true;
    video.setAttribute('aria-hidden', 'true');
    video.setAttribute('preload', 'metadata');
    if (poster) video.poster = poster;

    var source = document.createElement('source');
    source.src = src;
    source.type = 'video/mp4';
    video.appendChild(source);

    video.addEventListener('canplay', function once() {
      video.removeEventListener('canplay', once);
      requestAnimationFrame(function () {
        video.classList.add('is-ready');
      });
    });

    target.replaceWith(video);
    var play = video.play();
    if (play && typeof play.catch === 'function') play.catch(function () { /* autoplay blocked */ });
  }

  function init() {
    if (!shouldLoadVideo()) return;
    var targets = document.querySelectorAll('[data-cooked-video]');
    targets.forEach(attachVideo);
  }

  function whenIdle(fn) {
    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(fn, { timeout: 2000 });
    } else {
      setTimeout(fn, 200);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { whenIdle(init); });
  } else {
    whenIdle(init);
  }
})();
